import { render, staticRenderFns } from "./ApplicationRecovery.vue?vue&type=template&id=efadc68c&scoped=true&"
import script from "./ApplicationRecovery.vue?vue&type=script&lang=js&"
export * from "./ApplicationRecovery.vue?vue&type=script&lang=js&"
import style0 from "./ApplicationRecovery.vue?vue&type=style&index=0&id=efadc68c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efadc68c",
  null
  
)

export default component.exports